import { render, staticRenderFns } from "./UnitRepresentativeCollectionPage.vue?vue&type=template&id=53853028&"
import script from "./UnitRepresentativeCollectionPage.vue?vue&type=script&lang=ts&"
export * from "./UnitRepresentativeCollectionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53853028')) {
      api.createRecord('53853028', component.options)
    } else {
      api.reload('53853028', component.options)
    }
    module.hot.accept("./UnitRepresentativeCollectionPage.vue?vue&type=template&id=53853028&", function () {
      api.rerender('53853028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/UnitRepresentative/UnitRepresentativeCollectionPage.vue"
export default component.exports